import React, { Component, Fragment } from 'react';
import { createSelector } from 'reselect';

import { connect } from 'react-redux';
import MailHeader from '../../components/mailHeader';
import MailThread from './../../components/mailThread';
import TutorialEndPopup from './../../components/tutorialEndPopup';
import BackButton from './../../globals/images/arrow-back.svg'

import { autoSaveSurveyAnswers, setSurveyCompleteFlag, startCall, postData, saveDraft } from '../../actions/init';
import { addMailReadFlag, addMailStarredFlag, removeMailStarredFlag, setCurrentMailIndex, getTimeData } from './../../actions/mail/mailScheduler';
import { startTutorial, stopTutorial, addStepsToTutorial, updateStepNumber } from './../../actions/tutorial';
import { tutorialSequence, mailSequence } from './../../constants/tutorialSequence';
import './../../app.scss';


class MailThreadContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount = () => {
        let mailId = parseInt(this.props.match.params.id);
        setCurrentMailIndex(mailId)
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.mails !== nextProps.mails) {
            let mailId = parseInt(this.props.match.params.id);
            setCurrentMailIndex(mailId)
        }
        return true
    }

    getNextMailDetail = (mail) => mail.actionThread && mail.actionThread.find((action) => action.type === "next_mail");

    getNextMail = (activeMail) => {
        const { mails } = this.props
        return mails.find((mail) => {
            return mail.id === this.getNextMailDetail(activeMail).mailId;
        });
    }

    checkIfNextMailIsNotPrimary = (mailId) => {
        return this.props.mails.some(mail => mail.id === mailId && !mail.isPrimary);    //
    }

    isEndMail = (mail) => {
        const isMailHasresposne = this.getNextMailDetail(mail);
        let endMailFlag = isMailHasresposne;
        if (isMailHasresposne) {
            endMailFlag = this.checkIfNextMailIsNotPrimary(isMailHasresposne.mailId);
        }
        return !endMailFlag || mail.type === 'attachment';
    }

    goBack = () => {
        window.location.href = window.location.href.split('/').slice(0, -1).join('/');
    }

    getMailThread = (mail) => {
        if (this.isEndMail(mail)) {
            mail.isLastMail = true;
            return [mail];
        }
        const nextMail = this.getNextMail(mail);
        const mailThread = this.getMailThread(nextMail);
        return mailThread.length ? [mail, ...mailThread] : [mail, mailThread]
    }

    getResponseThread = (currentMail) => {
        //find NextMail 
        if (this.isEndMail(currentMail)) {
            // mutating pros 
            currentMail.isLastMail = true;
            return null;
        }

        const nextMail = this.getNextMail(currentMail);

        return this.getMailThread(nextMail);
    }

    getSubject = (subject) => (
        <div className='subject-container'>
            <div className='arrow-holder' onClick={this.goBack}>
                <img src={BackButton} />
            </div>
            <div className='subject-title'>
                <p> {subject}</p>
            </div>
        </div>
    );

    isCallTerminated = (actionThread) => {
        return actionThread.some((action) => action.type === 'call_terminated')
    }

    getCallStartedStatusForVoiceMail = (currentMail, calls) => {
        if (currentMail.type === "voice_mail") {
            let currentCall = calls.find(call => call.id === currentMail.nextMailId);
            return this.isCallTerminated(currentCall.actionThread)
        }
        return false
    }

    render() {
        const { currentMail, calls, actors, tutorial, orgChart, selfActor } = this.props;
        if (!currentMail) { return null; }
        const currentMailResponse = this.getResponseThread(currentMail)

        const lastMail = currentMailResponse ? currentMailResponse.find((mail) => this.isEndMail(mail)) : currentMail;
        return (
            <Fragment>
                {currentMail.isPrimary && this.getSubject(currentMail.subject)}
                <MailThread
                    {...this.props}
                    actors={actors}
                    currentMailResponse={currentMailResponse}
                    lastMail={lastMail}
                    addMailReadFlag={addMailReadFlag}
                    orgChart={orgChart}
                    selfActor={selfActor}
                    setSurveyCompleteFlag={setSurveyCompleteFlag}
                    postData={postData}
                    getTimeData={getTimeData}
                    saveDraft={saveDraft}
                    autoSaveSurveyAnswers={autoSaveSurveyAnswers}
                    getTimeData={getTimeData}
                    startCall={startCall}
                    addMailStarredFlag={addMailStarredFlag}
                    removeMailStarredFlag={removeMailStarredFlag}
                    tutorial={tutorial}
                    startTutorial={startTutorial}
                    stopTutorial={stopTutorial}
                    addStepsToTutorial={addStepsToTutorial}
                    updateStepNumber={updateStepNumber}
                    isCallCompleted={this.getCallStartedStatusForVoiceMail(currentMail, calls)}
                />
                {
                    tutorial.isTutorialEndPopupOpen ?
                        <TutorialEndPopup />
                        :
                        null
                }
            </Fragment>
        );

    }
}

const mapStateToProps = (state, ownProps) => {
    const { match } = ownProps;

    const { uiState, mails, calls, actors, tutorial } = state;
    const currentMail = mails.find((mail) => {
        return +mail.id === +match.params.id
    });
    return {
        uiState: uiState,
        currentMail: currentMail,
        mails: mails,
        calls: calls,
        actors: actors,
        orgChart: uiState.orgChart,
        selfActor: uiState.selfActor,
        tutorial
    };
};

export default connect(mapStateToProps, { postData, setSurveyCompleteFlag, saveDraft, setCurrentMailIndex, getTimeData })(MailThreadContainer);



// WEBPACK FOOTER //
// /src/containers/mailThreadContainer/MailThreadContainer.js